//import ViewDetailStudyListArea from "@/pages/comp/plan/study/study/common/view_detail_study_list";
import { useState, useRef, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import strFunc from '@/lib/lyg/string';
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import CoolenWordGroupResultPopup from "@/pages/comp/coolen/word_group/result/popup/group_result";
import Style from "./css/style.module.css";
import SectionListArea from "./area/section_list";

function ViewDetailStudyListArea(props: any) {
  let myProps = {
    stu_seq: "",
    study_title_seq: "",
    is_show_close_btn: true,
    close_btn_text: "닫기",
    on_click_close: () => { },
    ...props
  };

  const [use_list_opt, set_use_list_opt] = useState<any>({
    s_title_seq: myProps.study_title_seq,
    s_stu_seq: myProps.stu_seq,
    "s_addon_detail": "1",
    "s_addon_title": "1",
    "s_addon_section": "1",
    "s_addon_study": "1",
    "is_need_count": "",
    "is_need_info_arr": "1",
    "is_no_limit": "1",
  });
  const [study_use_info, set_study_use_info] = useState<any>({});

  const [popupData, setPopupData] = useState({
    isOpen: false,
    sort: "word_group_result",
    title: "결과",
    g_par_id: "",
    g_par_seq: "",
    stu_seq: "",
    width: "100%",
    height: "100%",
  });

  useEffect(() => {
    get_use_info_by_ajax({});
  }, []);

  const get_use_info_by_ajax = (inData: any) => {
    let opt_obj = {
      ...use_list_opt,
      ...inData
    };

    if (strFunc.is_empty(opt_obj["s_title_seq"])) {
      return false;
    }
    if (strFunc.is_empty(opt_obj["s_stu_seq"])) {
      return false;
    }

    set_use_list_opt(opt_obj);
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/study/study_use/list', opt_obj, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            set_study_use_info(response.data["data"]["info_arr"][0]);
          } else {
            alert("조회된 데이터가 없습니다.");
            myProps.on_click_close();
          }
        } else {

        }
      });
  };

  const open_word_group_result_popup = (inData:any) => {
    let opt_obj={
      g_par_id:"",
      g_par_seq:"",
      stu_seq:"",
      ...inData
    };

    if(strFunc.is_empty(opt_obj.g_par_id)){
      alert("그룹 구분이 없습니다.");
      return;
    }
    if(strFunc.is_empty(opt_obj.g_par_seq)){
      alert("그룹 키가 없습니다.");
      return;
    }
    if(strFunc.is_empty(opt_obj.stu_seq)){
      alert("학생 키가 없습니다.");
      return;
    }

    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "word_group_result",
      title: "결과보기",
      g_par_id: opt_obj.g_par_id,
      g_par_seq: opt_obj.g_par_seq,
      stu_seq: opt_obj.stu_seq
    });
  }

  return (
    <div>
      <SectionListArea
        Style={Style}
        study_use_info={study_use_info}
        open_word_group_result_popup={open_word_group_result_popup}
      ></SectionListArea>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} >
          {popupData.sort === "word_group_result" &&
            <CoolenWordGroupResultPopup
              g_par_id={popupData.g_par_id}
              g_par_seq={popupData.g_par_seq}
              stu_seq={popupData.stu_seq}
              callBackData={()=>{}}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></CoolenWordGroupResultPopup>
          }
        </LayerPopup>
      }
    </div>
  );
};
export default ViewDetailStudyListArea;